import { compareHelpers } from '@approvalmax/utils';
import { findCurrencyNameByCode } from 'modules/common/statics/currency';
import { useMemo } from 'react';
import { useGetSupportedCurrencies } from 'shared/data/walletsKyc/v1';

export const useSupportedCurrencies = () => {
    const { data, isLoading } = useGetSupportedCurrencies();

    const currencies = useMemo(
        () =>
            (data?.items || [])
                .map((currency) => ({
                    id: currency.currencyIsoCode,
                    name: findCurrencyNameByCode(currency.currencyIsoCode) || currency.currencyName,
                }))
                .sort((a, b) => compareHelpers.stringComparator2Asc(a.name, b.name)),
        [data?.items]
    );

    return {
        currencies,
        isCurrenciesLoading: isLoading,
    };
};
